import React from "react";

function IconCancelled(props) {
  return (
    <div className={props.className}>
        <svg
            height={props.height}
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 857 857"
            style={props.style}
            className={props.svgClass}
        >
        <path 
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M428.39 0c236.435 0 428.39 191.955 428.39 428.39 0 236.435-191.955 428.39-428.39 428.39C191.955 856.78 0 664.825 0 428.39 0 191.955 191.955 0 428.39 0zm269.962 220.318c44.469 57.594 70.928 129.767 70.928 208.072 0 188.142-152.748 340.89-340.89 340.89-78.305 0-150.478-26.459-208.072-70.928l478.034-478.034zm-61.87-61.874L158.444 636.482C113.972 578.903 87.5 506.714 87.5 428.39 87.5 240.248 240.248 87.5 428.39 87.5c78.324 0 150.513 26.472 208.092 70.944z"></path>
        </svg>
    </div>
  );
}

export default IconCancelled;
